const RoundedColoredDiv = ({ backgroundColor = '#F4BE37' }) => <div style={{ width: "8px", height: "8px", borderRadius: "100%", backgroundColor }} />;

export default RoundedColoredDiv
